import React from 'react'
import { Icon } from 'antd'

/**
 * Gom nhóm theo tên lô NGAY LÚC RENDER, state phía trên vẫn giữ mảng phẳng.
 * Thứ tự nhóm và thứ tự dòng trong nhóm đều theo thứ tự quét (mã mới nhất lên đầu).
 */
const groupByBatch = (items) => {
    const order = []
    const groups = {}

    items.forEach(item => {
        const { batch } = Object.assign({}, item)
        const name = (!!batch && batch.name) || '—'

        if (!groups[name]) {
            groups[name] = []
            order.push(name)
        }
        groups[name].push(item)
    })

    return order.map(name => ({ name, items: groups[name] }))
}

function ScannedItemList(props) {
    const { items, onRemove } = props
    const groups = groupByBatch(items)

    return (
        <div className='ScannedItemList'>
            <div className='ListHeader d-flex align-items-center mb-3'>
                <h3 className='ListTitle mb-0 mr-3'>Danh sách đã quét trong phiên</h3>
                <span className='ReadyBadge'>{items.length} item sẵn sàng ghi nhận</span>
            </div>

            {groups.map(group => (
                <div className='BatchGroup' key={group.name}>
                    <div className='GroupHeader d-flex align-items-center justify-content-between'>
                        <span className='BatchName'>Lô {group.name}</span>
                        <span className='GroupCount'>{group.items.length} item</span>
                    </div>

                    {group.items.map(item => (
                        <div className='ItemRow d-flex align-items-center' key={item.barcode_item}>
                            <Icon type='check' className='CheckIcon' />
                            <span className='Barcode'>#{item.barcode_item}</span>
                            <span className='Sku'>{item.sku}</span>
                            <span className='Size'>{item.size}</span>
                            <Icon
                                type='close'
                                className='RemoveIcon ml-auto'
                                title='Xoá khỏi danh sách'
                                onClick={() => onRemove(item.barcode_item)}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default ScannedItemList
